import { useState, type FormEvent } from "react";
import { useAuth } from "../hooks/useAuth";
import { ApiError } from "../api/client";

export function Login(): JSX.Element {
  const { login } = useAuth();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(ev: FormEvent): Promise<void> {
    ev.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(password);
    } catch (err) {
      if (err instanceof ApiError) setError(err.message);
      else setError("Login failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-8">
      <div className="w-full max-w-md">
        <div className="mb-12 text-center">
          <h1 className="font-serif text-[48px] leading-none tracking-brand">VALET</h1>
          <p className="mt-3 text-[11px] uppercase tracking-brand text-muted">counter-trading</p>
        </div>
        <form onSubmit={onSubmit} className="space-y-6">
          <div>
            <label className="label" htmlFor="pw">
              Password
            </label>
            <input
              id="pw"
              type="password"
              autoFocus
              autoComplete="current-password"
              className="input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
            />
          </div>
          {error && (
            <div className="text-xs text-err uppercase tracking-nav">{error}</div>
          )}
          <button
            type="submit"
            disabled={busy || password.length === 0}
            className="btn btn-primary w-full justify-center disabled:opacity-50"
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <p className="mt-10 text-[11px] text-muted text-center leading-relaxed">
          Single-user local bot. The password is set once via the <span className="font-mono">WEB_PASSWORD</span>{" "}
          environment variable and also encrypts all wallet secret keys stored in SQLite.
        </p>
      </div>
    </div>
  );
}
